import React from 'react';
import * as S from './HeaderRightAction.styles';
import { DesktopHeaderRightAction } from './DesktopHeaderRightAction';
import { useSaveScrollPositionActions } from '@/components/ScrollSaver/ScrollSaver.hooks';
import { useCustomPush } from '@/components/CustomLink/CustomLink.hooks';
import { useBridgeAPI, useBridgeState } from '@/bridge/hooks';
import { usePageType } from '@/hooks/usePageType/usePageType';
import { ROUTES } from '@/constants/routes';
import { PageType } from '@/hooks/usePageType/usePageType.types';
import { CloseWebviewIcon, PlusIcon } from '@/components/UI/Icons/Icons';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { useBreakpoint } from '@/hooks/useBreakpoint';

interface HeaderRightActionProps {
  isMain?: boolean;
  hasAddNew?: boolean;
  rightAction?: React.ReactNode;
}

export const HeaderRightAction = ({
  isMain,
  hasAddNew,
  rightAction,
}: HeaderRightActionProps) => {
  const saveScrollPositionActions = useSaveScrollPositionActions();
  const customPush = useCustomPush();
  const { isDesktop } = useBreakpoint();
  const { isWebView } = useBridgeState();
  const { closeWebview } = useBridgeAPI();
  const pageType = usePageType();

  function handleClick() {
    saveScrollPositionActions();
    customPush(ROUTES.newAd);
  }

  switch (true) {
    case isDesktop:
      return <DesktopHeaderRightAction />;
    case isWebView && (isMain || pageType === PageType.Search):
      return (
        <S.CloseWebviewBtn
          data-testid="close-webview-btn"
          onClick={closeWebview}
        >
          <CloseWebviewIcon />
        </S.CloseWebviewBtn>
      );
    case isMain || hasAddNew:
      return (
        <S.NewAdBtn
          id="new_ad_link"
          data-testid={CommonTestIds.header.newAdButton}
          onClick={handleClick}
        >
          <PlusIcon className="icon-plus" />
        </S.NewAdBtn>
      );
    default:
      return rightAction;
  }
};
